// Environment variables for Neuroa chat configuration
const chatkitKey = process.env.REACT_APP_CHATKIT_DOMAIN_KEY || "domain_pk";
const chatBackendUrl =
  process.env.REACT_APP_CHAT_BACKEND_URL || "http://localhost:3000";

// Warn if environment variables are not set
if (!process.env.REACT_APP_CHATKIT_DOMAIN_KEY) {
  console.warn(
    "⚠️ Missing REACT_APP_CHATKIT_DOMAIN_KEY environment variable. " +
      "Neuroa integration will not work properly. Please set this in your .env file.",
  );
}

if (!process.env.REACT_APP_CHAT_BACKEND_URL) {
  console.warn(
    "⚠️ Missing REACT_APP_CHAT_BACKEND_URL environment variable. " +
      "Using default localhost value. Please set this in your .env file for production.",
  );
}

// default configuration for Neuroa chat interface
const CHAT_CONFIG = {
  placeholder: "Conversa con Neuroa",
  startGreeting:
    "Hola, soy Neuroa 👋. ¿Qué te gustaría consultar sobre el estado de tu organización?",
  prompts: [
    {
      label: "¿Cómo usar Neuroa?",
      prompt:
        "Explícame cómo puedo usar Neuroa para entender mejor este dashboard.",
      icon: "circle-question",
    },
    {
      label: "Comparar periodos",
      prompt:
        "Compara este periodo con el anterior y dime las diferencias clave.",
      icon: "circle-question",
    },
  ],
  models: [
    {
      id: "gpt-5-mini",
      label: "Neuroa [gpt-5-mini]",
      description: "Modelo de razonamiento rápido",
      default: true,
    },
    {
      id: "gpt-5",
      label: "Neuroa [gpt-5]",
      description: "Modelo de razonamiento",
      default: false,
    },
    {
      id: "gpt-4o",
      label: "Neuroa [gpt-4o]",
      description: "Modelo rápido para el día a día",
      default: false,
    },
  ],
};

export { chatBackendUrl, chatkitKey, CHAT_CONFIG };
